module.exports = __webpack_public_path__ + "static/media/astSpahn.aeb56ed8.ttf";